"use strict";
/**
 * @module botbuilder
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * TurnState key for the OAuth login timeout
 */
exports.OAuthLoginTimeoutKey = 'loginTimeout';
/**
 * Name of the token polling settings key.
 */
exports.TokenPollingSettingsKey = "tokenPollingSettings";
/**
 *  Default amount of time an OAuthCard will remain active (clickable and actively waiting for a token).
 *  After this time:
 *  (1) the OAuthCard will not allow the user to click on it.
 *  (2) any polling triggered by the OAuthCard will stop.
 */
exports.OAuthLoginTimeoutMsValue = 900000;
//# sourceMappingURL=userTokenSettings.js.map